import { Route as ngRoute, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { ShellComponent } from 'src/app/shell/shell.component';

export class Route {
  static withShell(routes: Routes): ngRoute {
    return {
      path: '',
      component: ShellComponent,
      children: routes,
      data: { reuse: true },
     // canActivate: [MsalGuard],
    };
  }
}
